import { render } from "./DrawerMessenger.vue?vue&type=template&id=6fae2e7b"
import script from "./DrawerMessenger.vue?vue&type=script&lang=ts"
export * from "./DrawerMessenger.vue?vue&type=script&lang=ts"
script.render = render

export default script